module.exports = __webpack_public_path__ + "static/media/tools-multiple-elective.1ec8f572.svg";